// Pure RingCentral call_result -> human outcome mapping, extracted from
// App.tsx `formatCallTitle`. The ladder mixes explicit RC results with
// MISSED_CALL flags and 0-duration heuristics; keeping it pure makes the prior
// mis-labelling regressions testable. Behaviour identical to the inline ladder.

export interface CallOutcomeInput {
  /** Raw RC call_result (activity.call_result); may be null/empty. */
  callResult: string | null | undefined
  isOutbound: boolean
  /** MISSED_CALL flag the sync path writes when RC omits a result. */
  isMissed?: boolean
  durationSeconds?: number | null
}

export function normalizeCallOutcome(input: CallOutcomeInput): string {
  const { callResult, isOutbound, isMissed } = input
  const dur = input.durationSeconds
  const result = (callResult || '').toLowerCase()
  if (isMissed || result === 'missed') return isOutbound ? 'No answer' : 'Missed'
  if (result === 'voicemail') return isOutbound ? 'Left voicemail' : 'Voicemail'
  if (result === 'no answer') return 'No answer'
  if (result === 'busy') return 'Busy'
  if (result === 'wrong number') return 'Wrong number'
  if (result === 'answered' || result === 'accepted' || result === 'call connected') return 'Answered'
  if (result === 'answered elsewhere') return 'Answered elsewhere'
  if (result === 'hang up' || result === 'hung up') return 'Hung up'
  if (result === 'faxreceive' || result === 'fax receive') return 'Fax'
  if (!callResult && (!dur || dur === 0)) return isOutbound ? 'No answer' : 'Missed'
  if (dur && dur > 0) return 'Answered'
  return 'Logged'
}
